/**
 * Enum for allocation table fields
 * @readonly
 * @enum {Array}
 */
export const ALLOCATION_TABLE_FIELDS = Object.freeze([
	{ key: 'name', label: 'Rule name' },
	{ key: 'priority', label: 'Priority' },
	{ key: 'total_branches', label: 'Total branches' },
	{ key: 'online_ratio', label: 'Online ratio (%)' },
	{ key: 'min_qty', label: 'Min qty' },
	{ key: 'created_at', label: 'Date created' },
	{ key: 'status', label: 'Status' },
]);

/**
 * Enum for channel rule table fields
 * @readonly
 * @enum {Array}
 */
export const CHANNEL_RULE_TABLE_FIELDS = Object.freeze([
	{ key: 'channel_rule_name', label: 'Channel rule name' },
	{ key: 'priority', label: 'Priority' },
	{ key: 'total_sku', label: 'Total SKU' },
	{ key: 'conditions', label: 'Conditions' },
	{ key: 'created_at', label: 'Date created' },
	{ key: 'status', label: 'Status' },
]);

/**
 * Enum for online group
 * @readonly
 * @enum {Array}
 */
export const ONLINE_GROUP_TABLE_FIELDS = Object.freeze([
	{ key: 'branch_id', label: 'Branch id' },
	{ key: 'branch_name', label: 'Branch name' },
	{ key: 'assigned_at', label: 'Date assigned' },
]);

/**
 * Enum for allocation by
 * @readonly
 * @enum {Array}
 */
export const ALLOCATION_BY = Object.freeze({
	CATEGOTY: 'category',
	SKU: 'sku',
});
